import { FC } from 'react';
import ClearFilterButton from 'src/components/design-system/ClearFilterButton';
interface GridToolbarProps {
  clearFilter: () => void;
  isClearFiltersDisabled: boolean;
}

const GridToolbar: FC<GridToolbarProps> = ({ clearFilter, isClearFiltersDisabled }) => (
  <div className="flex items-center">
    <ClearFilterButton onClick={clearFilter} disabled={isClearFiltersDisabled} />
    <div className="text-white pt-1">Click on file name to rename</div>
  </div>
);

export default GridToolbar;
